// src/pages/ContactoPage.js
import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { Phone, Mail, MapPin, Instagram, Facebook } from 'lucide-react';
import './ContactoPage.css';

const ContactoPage = () => {
  // Estado para manejar los campos del formulario
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Aquí iría la lógica para enviar el formulario a un backend.
    // Por ahora, solo mostraremos una notificación de éxito.
    toast.success('¡Mensaje enviado! Te contactaremos pronto.');
    setFormData({ name: '', email: '', message: '' }); // Limpiamos el formulario
  };

  return (
    <div className="contact-page">
      <div className="container">
        <div className="contact-header">
          <h1>Contáctanos</h1>
          <p>¿Tienes preguntas o quieres hacer un pedido? Estamos aquí para ayudarte.</p>
        </div>

        <div className="contact-grid">
          {/* Columna de Información de Contacto */}
          <div className="contact-info">
            <h3>Información Directa</h3>
            <p><MapPin size={18} /> Cl. 54A #81B - 86, Ferrini, Medellín, Antioquia</p>
            <p><Phone size={18} /> WhatsApp: <a href="https://wa.me/573043882058">304 388 2058</a></p>
            <p><Phone size={18} /> WhatsApp: <a href="https://wa.me/573122725211">312 272 5211</a></p>

            <h3 className="social-title">Síguenos en Redes</h3>
            <div className="contact-social-icons">
              <a href="https://instagram.com/palomania2006" target="_blank" rel="noopener noreferrer"><Instagram /> @palomania2006</a>
              <a href="https://www.facebook.com/profile.php?id=100063773173295" target="_blank" rel="noopener noreferrer"><Facebook /> Palomania palitos con queso</a>
            </div>
          </div>

          {/* Columna del Formulario */}
          <div className="contact-form-container">
            <h3>Envíanos un Mensaje</h3>
            <form onSubmit={handleSubmit} className="contact-form">
              <input type="text" name="name" placeholder="Tu Nombre" value={formData.name} onChange={handleChange} required />
              <input type="email" name="email" placeholder="Tu Correo Electrónico" value={formData.email} onChange={handleChange} required />
              <textarea name="message" rows="6" placeholder="Tu Mensaje" value={formData.message} onChange={handleChange} required></textarea>
              <button type="submit" className="submit-button">Enviar Mensaje</button>
            </form>
          </div>
        </div>

        {/* Sección del Mapa */}
        <div className="map-section">
          <h3>Encuéntranos Aquí</h3>
          <div className="map-responsive">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3966.1102927236523!2d-75.60925768569503!3d6.24941992809569!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e5258676a751681%3A0x933b52a49336916!2sCl.%2054A%20%2381B-86%2C%20Ferrini%2C%20Medell%C3%ADn%2C%20Antioquia!5e0!3m2!1ses-419!2sco!4v1690694000000!5m2!1ses-419!2sco"
              width="600"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Ubicación de Palomanía"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactoPage;